import Auth, { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { graphql, Link, navigate } from 'gatsby'
import { TFunction } from 'i18next'
import React, { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import {
  checkIfSubmittable,
  getEmailDomainBlockedMessage,
  isEmailDomainBlockedError,
  validateEmailDomain,
  validation,
} from '../../utils/validation'
import appleIcon from '../assets/images/apple_logo.svg'
import emailIcon from '../assets/images/email.svg'
import googleIcon from '../assets/images/google_logo.svg'
// import facebookIcon from '../assets/images/facebook_logo.svg'
// import birdAvatar from '../assets/images/chirpyest-white.svg'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@material-ui/core'
import { useLocation } from '@reach/router'
import clx from 'classnames'
import * as moment from 'moment'
import {
  AWS_AUTH_RETRY_CONFIG,
  completeSignUpAuth,
  establishSignInAuth,
  getAuthAccessToken,
  getUserIdFromAuth,
  resolveSignInSession,
} from '../../utils/completeSignUpAuth'
import { callWithRetry } from '../../utils/retry'
import { setItemToLocalStorage } from '../../utils/setLocalStorage'
import {
  getOtpVerificationErrorMessage,
  getVerifyContinueErrorMessage,
} from '../../utils/signupErrors'
import {
  clearSignupOtpSessionStorage,
  formatBlockedUntil,
  formatResendTimer,
  getOtpVerifyRateLimitMessage,
  getRemainingCooldownSeconds,
  persistOtpSendBlocked,
  persistOtpSendSuccess,
  restoreOtpResendFromSessionStorage,
  SIGNUP_OTP_CLEANUP_KEYS,
  SIGNUP_OTP_RESEND_KEYS,
} from '../../utils/signupOtpResendBackoff'
import { TrackingCase } from '../../utils/trackingCases'
import { buildFinancialData } from '../../utils/financialData'
import { useAppState } from '../appState'
import blackLogo from '../assets/images/chirpyest-logo.svg'
import axios from '../axios'
import CHRButton from '../components/button'
import CHRFloatImageLeft from '../components/floatImageLeft'
import CHRFloatImageRight from '../components/floatImagRight'
import CHRInput from '../components/input'
import IOSSwitch from '../components/IOSSwitch'
import PinExtensionReminderPopOut from '../components/popOuts/pinExtensionReminderPopOut'
import SEO from '../components/seo'
import SignInModal from '../components/signInModal'
import CHRText from '../components/typography'
import Layout from '../layouts/defaultLayout'
import { styles } from '../pagesStyles/joinsStyles'
import { tracker } from '../systemLogs'
import {
  sendExtensionMessage,
  sendToExtension,
} from './../../utils/extensionHelper'
import { isUserAuthenticated } from './../../utils/isUserAuthenticated'
import CHRArrowButton from './../components/arrowButton'
import BlockUserInterface from './../components/blockUserInterface'
import ContentContainer from './../components/contentContainer'
import CHROutlinedButton from './../components/outlinedButton'
import CHRSectionContainer from './../components/sectionContainer'
import {
  baseURL,
  ENDPOINTS,
  EXTENSION_ID,
  FONTS,
  ROUTES,
  TYPOGRAPHY_ALIGNMENT,
  TYPOGRAPHY_SIZES,
} from './../constants'

const eye = <FontAwesomeIcon icon={faEye} />
const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />

const referralIdRegex = /(.*-.*)/
interface JoinProps {
  t: TFunction
  data: any
}

const Join = ({ t, data }: JoinProps) => {
  const [email, setEmail] = useState('')
  const [appState] = useAppState()
  const [password, setPassword] = useState('')
  const [isTermsChecked, setIsTermsChecked] = useState(true)
  const [isNewsletterChecked, setIsNewsletterChecked] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isExtensionDownloaded, setIsExtensionDownloaded] = useState(false)
  const [passwordShown, setPasswordShown] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [gateEnabled, setGateEnabled] = useState(false)
  const [state, dispatch] = useAppState()
  const [formErrors, setFormErrors] = useState({
    emailValidationError: false,
    emailErrorText: '',
    passwordValidationError: false,
    passwordErrorText: '',
    requestError: false,
    requestErrorText: '',
  })
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [inviteAccepted, setInviteAccepted] = useState(false)
  const [isOpenSignInModal, setIsOpenSignInModal] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [signupStep, setSignupStep] = useState<'form' | 'verify'>('form')
  const [otpValue, setOtpValue] = useState('')
  const [otpError, setOtpError] = useState('')
  const [otpInfo, setOtpInfo] = useState('')
  const [resendCooldown, setResendCooldown] = useState(60)
  const [resendTimer, setResendTimer] = useState(60)
  const [resendEnabled, setResendEnabled] = useState(false)
  const [isBlocked, setIsBlocked] = useState(false)
  const [blockedUntil, setBlockedUntil] = useState<Date | null>(null)
  const [isUnverifiedResignup, setIsUnverifiedResignup] = useState(false)
  const [showSignInLink, setShowSignInLink] = useState(false)
  const otpInputRef = useRef<HTMLInputElement>(null)
  const pendingUserData = useRef<any>(null)
  const [storageReady, setStorageReady] = useState(false)

  const startCountdown = (seconds: number) => {
    persistOtpSendSuccess(seconds)
    setIsBlocked(false)
    setBlockedUntil(null)
    setResendCooldown(seconds)
    setResendTimer(seconds)
    setResendEnabled(false)
  }

  const handleOtpSendRateLimit = (data: OtpSendRateLimitData) => {
    if (data.isBlocked && data.blockedUntil) {
      const blocked = new Date(data.blockedUntil)
      setIsBlocked(true)
      setBlockedUntil(blocked)
      setResendEnabled(false)
      persistOtpSendBlocked(blocked)
      return
    }

    const remaining = getRemainingCooldownSeconds(data)
    if (remaining !== null && remaining > 0) {
      startCountdown(remaining)
    }
  }

  useEffect(() => {
    const restored = restoreOtpResendFromSessionStorage()
    if (restored.email !== undefined) setEmail(restored.email)
    if (restored.password !== undefined) setPassword(restored.password)
    if (restored.signupStep !== undefined) setSignupStep(restored.signupStep)
    if (restored.isBlocked) {
      setIsBlocked(true)
      setBlockedUntil(restored.blockedUntil ?? null)
    } else {
      if (restored.resendTimer !== undefined)
        setResendTimer(restored.resendTimer)
      if (restored.resendEnabled !== undefined) {
        setResendEnabled(restored.resendEnabled)
      }
    }
    setStorageReady(true)
  }, [])

  useEffect(() => {
    if (!storageReady) return
    sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.email, email)
  }, [email, storageReady])

  useEffect(() => {
    if (!storageReady) return
    sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.password, password)
  }, [password, storageReady])

  useEffect(() => {
    if (!storageReady) return
    sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.step, signupStep)
  }, [signupStep, storageReady])

  useEffect(() => {
    if (!storageReady) return
    sessionStorage.setItem(
      SIGNUP_OTP_RESEND_KEYS.resendTimer,
      String(resendTimer)
    )
  }, [resendTimer, storageReady])

  useEffect(() => {
    if (!storageReady) return
    sessionStorage.setItem(
      SIGNUP_OTP_RESEND_KEYS.resendEnabled,
      String(resendEnabled)
    )
  }, [resendEnabled, storageReady])

  useEffect(() => {
    if (signupStep === 'verify') {
      otpInputRef.current?.focus()
    }
  }, [signupStep])

  useEffect(() => {
    if (signupStep !== 'verify' || resendEnabled || isBlocked) return
    if (resendTimer <= 0) {
      setResendEnabled(true)
      return
    }
    const id = setTimeout(() => setResendTimer(t => t - 1), 1000)
    return () => clearTimeout(id)
  }, [signupStep, resendTimer, resendEnabled, isBlocked])

  const [param] = window.location.search.slice(1).split('&')
  const { pathname } = useLocation()
  const referralId = pathname?.split('/')[2]?.split('#')[0] || ''

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown)
  }

  // redirect user to members page instead of join page
  useEffect(() => {
    if (appState.userId) navigate(ROUTES.member) // Commented because we need to access join page even if we are logged in
  }, [])

  useEffect(() => {
    if (referralId) {
      setItemToLocalStorage(
        'referralId',
        JSON.stringify({ id: referralId, time: moment().format() })
      )
    }

    getSettings().then(() => {
      if (
        param.split('=')[0] === 'fromExtension' &&
        param.split('=')[1] === 'true'
      ) {
        setItemToLocalStorage('extensionDownloaded', 'true')
        isUserAuthenticated().then(result => {
          if (!!result) {
            navigate(ROUTES.member, { state: { showPopUp: true } })
          } else {
            setIsModalOpen(true)
            setIsExtensionDownloaded(true)
            setIsPageLoading(false)
          }
        })
      } else {
        setIsPageLoading(false)
        const isExtensionInstalled = window.localStorage.getItem(
          'extensionDownloaded'
        )
        if (isExtensionInstalled && isExtensionInstalled === 'true') {
          setIsExtensionDownloaded(true)
        }
        return
      }
    })
  }, [])

  // TODO: useless function, remove it or use it in the future
  const getSettings = async () => {
    try {
      const settings = await axios.get(`${baseURL}${ENDPOINTS.settings}`)
      setGateEnabled(settings?.data?.data[0]?.setting_value?.gateEnabled)
    } catch (err) {
      setGateEnabled(true)
    }
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const closeSignInModal = () => {
    setIsOpenSignInModal(false)
  }

  const handleAutoSignIn = async (email: string, password: string) => {
    setIsSubmitting(true)

    // Check for restricted domains
    const domainValidation = await validateEmailDomain(email, 'signin')
    if (!domainValidation.isValid) {
      setFormErrors({
        emailValidationError: true,
        emailErrorText: domainValidation.errorMessage || 'Invalid email domain',
        passwordValidationError: false,
        passwordErrorText: '',
        requestError: true,
        requestErrorText:
          domainValidation.errorMessage || 'Invalid email domain',
      })
      setIsSubmitting(false)
      return
    }

    try {
      const normalizedEmail = email.trim().toLowerCase()
      const { data: signInResponse } = await axios.post(ENDPOINTS.signIn, {
        email: normalizedEmail,
        password,
      })
      const { user, authPayload } = await establishSignInAuth(
        signInResponse?.data,
        normalizedEmail,
        password,
        AWS_AUTH_RETRY_CONFIG
      )
      const { accessToken, session, userId } = await resolveSignInSession(
        user,
        authPayload,
        AWS_AUTH_RETRY_CONFIG
      )

      if (!session && !accessToken) {
        throw new Error(t('messages.notAuthorized'))
      }

      const {
        data: { data },
      } = await axios.get(ENDPOINTS.user.replace(':id', userId), {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      const currentUserInfo = await Auth.currentCredentials()
      const userProfile = {
        email: data.email,
        userName: data.username,
        fullName: data.name,
        imageKey: data.image,
        imageUrl: '' as Object | string,
        isPro: data.isPro,
        isCreator: data.isCreator,
        isReferralBonus: data.isReferralBonus,
        userDoublePayment: data.userDoublePayment,
        financialData: buildFinancialData(data.financialData),
        loginProvider: data.loginProvider,
        isShortLinkReferralAllowed: data.isShortLinkReferralAllowed,
        shareLinkSegment: data.shareLinkSegment,
        shareLinkDeclaredAt: data.shareLinkDeclaredAt,
        shareLinkReviewStatus: data.shareLinkReviewStatus,
        canCreateForwardableBoards: data.canCreateForwardableBoards || false,
        canCreateEditPage: data.canCreateEditPage || false,
        defaultShoppingBoardView: data.defaultShoppingBoardView,
        isPowerUser: data.isPowerUser,
      }

      if (data.image && currentUserInfo?.identityId) {
        const url = `https://${process.env.GATSBY_S3_BUCKET_NAME}.s3.us-east-2.amazonaws.com/public/${data.image}`
        userProfile.imageUrl = url
      }

      sendExtensionMessage({ session })
      sendToExtension('CHR_AUTH_SESSION', { auth: session })

      if (window.chrome?.runtime?.sendMessage) {
        window.chrome.runtime.sendMessage(
          EXTENSION_ID,
          { session },
          _response => {}
        )
      }

      dispatch({ type: 'SIGN_IN', auth: user, userProfile })
      SIGNUP_OTP_CLEANUP_KEYS.forEach(key => sessionStorage.removeItem(key))

      const urlParams = new URLSearchParams(window.location.search)
      const signInFromExtension = urlParams.get('signInFromExtension')

      navigate(
        `${ROUTES.member}${
          signInFromExtension ? '?signInFromExtension=signInFromExtension' : ''
        }`
      )
    } catch (err) {
      setFormErrors({
        requestError: true,
        requestErrorText: 'An account with this email already exists',
      })
    }
    setIsSubmitting(false)
  }

  const handleSignUp = async () => {
    setIsSubmitting(true)
    setFormErrors({
      emailValidationError: false,
      emailErrorText: '',
      passwordValidationError: false,
      passwordErrorText: '',
      requestError: false,
      requestErrorText: '',
    })
    setShowSignInLink(false)
    try {
      // Check for restricted domains
      const domainValidation = await validateEmailDomain(email, 'signup')
      if (!domainValidation.isValid) {
        setFormErrors({
          emailValidationError: true,
          emailErrorText:
            domainValidation.errorMessage || 'Invalid email domain',
          passwordValidationError: false,
          passwordErrorText: '',
          requestError: false,
          requestErrorText: '',
        })
        setIsSubmitting(false)
        return
      }

      const isFormValid = await validation({ email, password })
      if (isTermsChecked && isFormValid) {
        let userData = {
          email,
          password,
          termsCondsAccepted: isTermsChecked,
          newsletterSubscription: isNewsletterChecked,
          extensionDownloaded: isExtensionDownloaded,
        }
        if (referralId) {
          Object.assign(userData, { referral: referralId })
        } else {
          const referralIdFallBackJSON = window.localStorage.getItem(
            'referralId'
          )
          const referralIdFallBack = JSON.parse(referralIdFallBackJSON)
          if (referralIdFallBack) {
            const { id, time } = referralIdFallBack
            const referralIdAge = moment().diff(moment(time), 'days')
            if (referralIdAge <= 3) {
              Object.assign(userData, { referral: id })
            }
          }
        }
        pendingUserData.current = userData
        tracker.track(
          TrackingCase.UserTracking,
          `POST ${ENDPOINTS.sendVerificationOtp}`,
          {
            location: 'Join',
            email,
          }
        )
        const { data } = await axios.post(ENDPOINTS.sendVerificationOtp, {
          email,
        })
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.email, email)
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.password, password)
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.step, 'verify')
        setOtpValue('')
        setOtpError('')
        setOtpInfo('')
        startCountdown(data?.cooldownSeconds ?? 60)
        setIsUnverifiedResignup(data?.isUnverified === true)
        setSignupStep('verify')
      }
    } catch (error) {
      const responseError = (error as {
        response?: { status?: number; data?: any }
      })?.response

      if (isEmailDomainBlockedError(error)) {
        setFormErrors({
          emailValidationError: true,
          emailErrorText: getEmailDomainBlockedMessage(error),
          passwordValidationError: false,
          passwordErrorText: '',
          requestError: false,
          requestErrorText: '',
        })
        setIsSubmitting(false)
        return
      }

      if (responseError?.status === 429 && responseError.data) {
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.email, email)
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.password, password)
        sessionStorage.setItem(SIGNUP_OTP_RESEND_KEYS.step, 'verify')
        setSignupStep('verify')
        handleOtpSendRateLimit(responseError.data)
        setIsSubmitting(false)
        return
      }

      if (error.errors) {
        if (error.inner[0]?.params.path === 'email') {
          setFormErrors({
            emailValidationError: true,
            emailErrorText: error.inner[0]?.message,
            passwordValidationError:
              error.inner[1]?.params?.path === 'password',
            passwordErrorText: error.inner[1]?.message,
          })
        } else {
          setFormErrors({
            passwordErrorText: error.inner[0]?.message,
            passwordValidationError:
              error.inner[0]?.params?.path === 'password',
          })
        }
      } else {
        let errMsg = t('join.errorCreatingANewAccount')
        if (responseError) {
          const loginProvider =
            responseError.data.loginProvider?.toLowerCase() || ''
          const socialProvider = loginProvider.includes('google')
            ? 'Google'
            : 'Apple'
          const isConflict = responseError.status === 409
          const isSocialProvider =
            loginProvider.includes('google') || loginProvider.includes('apple')

          if (isConflict && isSocialProvider) {
            errMsg = `You have already singed in with this email with ${socialProvider}`
            setTimeout(() => {
              setEmail('')
              setPassword('')
              setFormErrors({
                emailValidationError: false,
                emailErrorText: '',
                passwordValidationError: false,
                passwordErrorText: '',
                requestError: false,
                requestErrorText: '',
              })
              setIsOpenSignInModal(true)
            }, 3000)
          } else if (isConflict) {
            return handleAutoSignIn(email, password)
          }
        }

        setFormErrors({
          requestError: true,
          requestErrorText: errMsg,
        })
      }
    }

    setIsSubmitting(false)
  }

  const handleSignInLinkClick = () => {
    setFormErrors({
      emailValidationError: false,
      emailErrorText: '',
      passwordValidationError: false,
      passwordErrorText: '',
      requestError: false,
      requestErrorText: '',
    })
    setShowSignInLink(false)
    setIsOpenSignInModal(true)
  }

  const handleCreateAccount = async () => {
    setIsSubmitting(true)
    setOtpError('')

    if (!otpValue || otpValue.length !== 6) {
      setOtpError('Please enter the 6-digit code.')
      setIsSubmitting(false)
      return
    }

    try {
      const { data: verifyData } = await axios.post(ENDPOINTS.verifyEmailOtp, {
        email,
        otp: otpValue,
      })

      const userData = pendingUserData.current || {
        email,
        password,
        termsCondsAccepted: isTermsChecked,
        newsletterSubscription: isNewsletterChecked,
        extensionDownloaded: isExtensionDownloaded,
      }

      if (verifyData?.requiresCognitoVerification) {
        await axios.post(ENDPOINTS.verifyCognitoEmail, { email, password })
      }

      const awsRetryConfig = {
        timeout: 5 * 1000,
        maxRetries: 3,
        waitBetweenTries: 2 * 1000,
      }
      const { data: signUpResponse } = await axios.post(
        ENDPOINTS.signUp,
        userData
      )

      const signUpAuthPayload = signUpResponse?.data
      const user = await completeSignUpAuth(
        signUpAuthPayload,
        userData.email,
        userData.password,
        awsRetryConfig
      )

      setItemToLocalStorage('signUp', 'firstVisit')
      setItemToLocalStorage('firstMove', 'true')

      if (user) {
        const accessToken = await getAuthAccessToken(user, signUpAuthPayload)
        const currentSession = await callWithRetry(
          () => Auth.currentSession(),
          awsRetryConfig
        )

        if (!currentSession && !accessToken) {
          navigate(ROUTES.signIn)
        } else {
          const userId = getUserIdFromAuth(user, signUpAuthPayload)
          const {
            data: { data },
          } = await axios.get(ENDPOINTS.user.replace(':id', userId), {
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          const userProfile = {
            email: data.email,
            userName: data.username,
            fullName: data.name,
            imageKey: data.image,
            imageUrl: '' as Object | string,
            isPro: data.isPro,
            isCreator: data.isCreator,
            isReferralBonus: data.isReferralBonus,
            userDoublePayment: data.userDoublePayment,
            financialData: buildFinancialData(data.financialData),
            loginProvider: data.loginProvider,
            isShortLinkReferralAllowed: data.isShortLinkReferralAllowed,
            shareLinkSegment: data.shareLinkSegment,
            shareLinkDeclaredAt: data.shareLinkDeclaredAt,
            shareLinkReviewStatus: data.shareLinkReviewStatus,
            canCreateForwardableBoards:
              data.canCreateForwardableBoards || false,
            canCreateEditPage: data.canCreateEditPage || false,
            defaultShoppingBoardView: data.defaultShoppingBoardView,
            isPowerUser: data.isPowerUser,
          }

          if (data.image && currentSession?.identityId) {
            const url = `https://${process.env.GATSBY_S3_BUCKET_NAME}.s3.us-east-2.amazonaws.com/public/${data.image}`
            userProfile.imageUrl = url
          }
          sendExtensionMessage({ session: currentSession })
          sendToExtension('CHR_AUTH_SESSION', { auth: currentSession })
          if (window.chrome?.runtime?.sendMessage) {
            window.chrome.runtime.sendMessage(
              EXTENSION_ID,
              { session: currentSession },
              _response => {}
            )
          }

          dispatch({ type: 'SIGN_IN', auth: user, userProfile })
          clearSignupOtpSessionStorage()
          navigate(ROUTES.personalInfo)
        }
      }
    } catch (error) {
      const responseError = error.response

      if (responseError?.status === 400) {
        setOtpError(
          getOtpVerificationErrorMessage(responseError?.data?.message)
        )
      } else if (responseError?.status === 429) {
        if (responseError.data) {
          handleOtpSendRateLimit(responseError.data)
        }
        setOtpError(getOtpVerifyRateLimitMessage(responseError.data))
      } else {
        const loginProvider =
          responseError?.data?.loginProvider?.toLowerCase() || ''
        const isConflict = responseError?.status === 409
        const isSocialProvider =
          loginProvider.includes('google') || loginProvider.includes('apple')

        if (isConflict && !isSocialProvider && !isUnverifiedResignup) {
          setIsSubmitting(false)
          return handleAutoSignIn(email, password)
        }

        let errMsg = getVerifyContinueErrorMessage(
          error,
          t('join.errorCreatingANewAccount')
        )
        if (isConflict && isUnverifiedResignup) {
          errMsg =
            'Unable to complete registration. Please try again or contact support.'
        }
        if (isConflict && isSocialProvider) {
          const socialProvider = loginProvider.includes('google')
            ? 'Google'
            : 'Apple'
          errMsg = `You have already singed in with this email with ${socialProvider}`
        }
        setOtpError(errMsg)
      }
    }

    setIsSubmitting(false)
  }

  const handleResendOtp = async () => {
    if (!resendEnabled || isBlocked) return
    setOtpError('')
    setOtpInfo('')
    setIsSubmitting(true)
    try {
      const { data } = await axios.post(ENDPOINTS.sendVerificationOtp, {
        email,
      })
      setOtpValue('')
      startCountdown(data?.cooldownSeconds ?? resendCooldown)
      setOtpInfo('A new code has been sent to your email.')
    } catch (error) {
      if (error.response?.status === 429 && error.response.data) {
        handleOtpSendRateLimit(error.response.data)
      } else {
        setOtpError('Could not resend the code. Please try again.')
      }
    }
    setIsSubmitting(false)
  }

  const handleBackToForm = () => {
    clearSignupOtpSessionStorage()
    setSignupStep('form')
    setOtpValue('')
    setOtpError('')
    setOtpInfo('')
    setResendCooldown(60)
    setResendTimer(60)
    setResendEnabled(false)
    setIsBlocked(false)
    setBlockedUntil(null)
    setIsUnverifiedResignup(false)
  }

  const classes = styles()

  const handleNewslettersSwitch = () => {
    setIsNewsletterChecked(!isNewsletterChecked)
  }

  const handleTermsSwitch = () => {
    setIsTermsChecked(!isTermsChecked)
  }

  if (isPageLoading) {
    return <BlockUserInterface />
  }

  const isInvite =
    referralId && !inviteAccepted && referralIdRegex.test(referralId)

  const JoinArrowButton = ({ isFloatRight }: { isFloatRight: boolean }) => (
    <div
      className={clx({
        [classes.customWidth7]: isFloatRight,
      })}
    >
      <div
        className={clx(classes.addChirpyestBtn, {
          [classes.floatRightButton]: isFloatRight,
        })}
      >
        <CHRArrowButton
          label={t('shared.join')}
          onClick={() => {
            setInviteAccepted(true)
            window.scroll({
              top: 0,
              behavior: 'smooth',
            })
          }}
          hoverEffects={true}
        />
      </div>
    </div>
  )

  return (
    <>
      {!isPageLoading && (
        <Layout isJoinPage={isInvite}>
          <SEO
            title={t('join.metaTitle')}
            description={t('join.metaDescription')}
            keywords={t('join.keywords')}
          />
          <ContentContainer>
            {isInvite ? (
              <div className={classes.coloredHeader}>
                <div
                  className={[
                    classes.container,
                    classes.welcomeMessageContainer,
                    classes.edgeSpace,
                  ].join(' ')}
                >
                  <CHRText
                    size={TYPOGRAPHY_SIZES.big}
                    align={TYPOGRAPHY_ALIGNMENT.left}
                    style={{
                      marginBottom: 10,
                      textAlign: 'center',
                    }}
                  >
                    <span
                      className={[
                        classes.findYourVoiceContainer,
                        classes.desktop,
                        classes.whiteText,
                      ].join(' ')}
                    >
                      {t('join.welcomeToChirpyest')}
                    </span>
                    <span
                      className={[
                        classes.welcomeMessageTypography,
                        classes.mobile,
                        classes.whiteText,
                      ].join(' ')}
                    >
                      {t('join.welcomeToChirpyest')}
                    </span>
                  </CHRText>
                  <CHRText
                    align="center"
                    className={classes.invitationContainer}
                  >
                    <span
                      className={[
                        classes.desktop,
                        classes.invitationTypography,
                        classes.invitationTypographyDesktop,
                        classes.whiteText,
                      ].join(' ')}
                    >
                      {t('join.privateInvitation', {
                        username: referralId.split('-')[0],
                      })}
                    </span>
                    <span
                      className={[
                        classes.mobile,
                        classes.cashBackMobileContainer,
                        classes.invitationTypography,
                        classes.whiteText,
                      ].join(' ')}
                    >
                      {t('join.privateInvitation', {
                        username: referralId.split('-')[0],
                      })}
                    </span>
                  </CHRText>
                  <div
                  // className={classes.customWidth7}
                  >
                    <CHRButton
                      onClick={() => setInviteAccepted(true)}
                      label={t('shared.joinChirpyest')}
                      icon={blackLogo}
                      customStyle={[
                        classes.buttonStyles,
                        classes.customWidth7,
                        classes.coloredButton,
                      ].join(' ')}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <form className={classes.container}>
                {gateEnabled ? (
                  <>
                    <CHRText
                      size={TYPOGRAPHY_SIZES.big}
                      align={TYPOGRAPHY_ALIGNMENT.left}
                      style={{
                        alignSelf: 'center',
                      }}
                    >
                      <span
                        className={[
                          classes.findYourVoiceContainer,
                          classes.desktop,
                        ].join(' ')}
                      >
                        {t('join.findYourVoice')}
                      </span>
                      <span
                        className={[
                          classes.findYourVoiceMobileContainer,
                          classes.mobile,
                        ].join(' ')}
                      >
                        {t('join.findYourVoice')}
                      </span>
                    </CHRText>
                    <CHRText
                      align="center"
                      style={{
                        marginBottom: 0,
                        alignSelf: 'center',
                      }}
                    >
                      <span
                        className={[
                          classes.desktop,
                          classes.cashBackContainer,
                          classes.cashBackDesktopContainer,
                        ].join(' ')}
                      >
                        {t('join.cashBackBrands')}
                      </span>
                      <span
                        className={[
                          classes.mobile,
                          classes.cashBackContainer,
                          classes.cashBackMobileContainer,
                        ].join(' ')}
                      >
                        {t('join.cashBackBrands')}
                      </span>
                    </CHRText>
                    <CHRText align="center">
                      <span
                        className={[
                          classes.desktop,
                          classes.joinNowContainer,
                        ].join(' ')}
                      >
                        {t('join.joinNow')}
                      </span>
                      <span
                        className={[
                          classes.mobile,
                          classes.joinNowContainer,
                          classes.joinNowMobileContainer,
                        ].join(' ')}
                      >
                        {t('join.joinNow')}
                      </span>
                    </CHRText>
                  </>
                ) : (
                  <>
                    <CHRText
                      size={TYPOGRAPHY_SIZES.big}
                      align={TYPOGRAPHY_ALIGNMENT.left}
                      style={{
                        alignSelf: 'center',
                      }}
                    >
                      <span
                        className={[
                          classes.findYourVoiceContainer,
                          classes.desktop,
                        ].join(' ')}
                      >
                        {t('join.findYourVoice')}
                      </span>
                      <span
                        className={[
                          classes.findYourVoiceMobileContainer,
                          classes.mobile,
                        ].join(' ')}
                      >
                        {t('join.findYourVoice')}
                      </span>
                    </CHRText>
                    <CHRText
                      align="center"
                      style={{
                        marginBottom: 0,
                        alignSelf: 'center',
                      }}
                    >
                      <span
                        className={[
                          classes.desktop,
                          classes.cashBackContainer,
                          classes.cashBackDesktopContainer,
                        ].join(' ')}
                      >
                        {t('join.cashBackBrands')}
                      </span>
                      <span
                        className={[
                          classes.mobile,
                          classes.cashBackContainer,
                          classes.cashBackMobileContainer,
                        ].join(' ')}
                      >
                        {t('join.cashBackBrands')}
                      </span>
                    </CHRText>
                    <CHRText align="center">
                      <span
                        className={[
                          classes.desktop,
                          classes.joinNowContainer,
                        ].join(' ')}
                      >
                        {t('join.joinNow')}
                      </span>
                      <span
                        className={[
                          classes.mobile,
                          classes.joinNowContainer,
                          classes.joinNowMobileContainer,
                        ].join(' ')}
                      >
                        {t('join.joinNow')}
                      </span>
                    </CHRText>
                  </>
                )}
                <p className={classes.error}>
                  {formErrors.emailValidationError && formErrors.emailErrorText}
                </p>
                <CHRInput
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value)
                  }}
                  placeholder={t('shared.emailAddress')}
                  type="email"
                  error={formErrors.emailValidationError}
                  required
                  disabled={signupStep === 'verify'}
                  onKeyPress={event =>
                    !isSubmitting && checkIfSubmittable(event, handleSignUp)
                  }
                  autoComplete="new-password"
                />
                <p className={classes.error}>
                  {formErrors.passwordValidationError &&
                    formErrors.passwordErrorText}
                </p>
                <div className={classes.passwordField}>
                  <CHRInput
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value)
                    }}
                    placeholder={t('shared.password')}
                    type={passwordShown ? 'text' : 'password'}
                    error={formErrors.passwordValidationError}
                    required
                    disabled={signupStep === 'verify'}
                    onKeyPress={event =>
                      !isSubmitting && checkIfSubmittable(event, handleSignUp)
                    }
                    autoComplete="new-password"
                  />
                  <i
                    className={classes.passVisibility}
                    onClick={togglePasswordVisibility}
                  >
                    {passwordShown ? eye : eyeSlash}
                  </i>
                </div>
                {signupStep === 'form' && (
                  <p className={classes.passwordGuidelines}>
                    {t('join.passwordGuidelines')}
                  </p>
                )}

                {signupStep === 'verify' && (
                  <>
                    <p
                      className={classes.switchLabel}
                      style={{ textAlign: 'center', marginTop: 8 }}
                    >
                      {isUnverifiedResignup
                        ? `You previously signed up but didn't verify. We sent a new code to ${email}.`
                        : `We sent a 6-digit code to ${email}.`}{' '}
                      <span
                        className={`${classes.clickable} ${classes.underLinedText}`}
                        onClick={handleBackToForm}
                      >
                        Change email
                      </span>
                    </p>
                    <CHRInput
                      value={otpValue}
                      onChange={e =>
                        setOtpValue(
                          e.target.value.replace(/\D/g, '').slice(0, 6)
                        )
                      }
                      placeholder="6-digit code"
                      type="text"
                      elementRef={otpInputRef}
                      onKeyPress={event =>
                        !isSubmitting &&
                        checkIfSubmittable(event, handleCreateAccount)
                      }
                      autoComplete="one-time-code"
                    />
                    {otpError && <p className={classes.error}>{otpError}</p>}
                    {otpInfo && (
                      <p
                        className={classes.switchLabel}
                        style={{ color: 'green', textAlign: 'center' }}
                      >
                        {otpInfo}
                      </p>
                    )}
                    <p style={{ textAlign: 'center' }}>
                      {isBlocked && blockedUntil ? (
                        <span style={{ opacity: 0.5 }}>
                          Too many attempts. You can try again on{' '}
                          {formatBlockedUntil(blockedUntil)}.
                        </span>
                      ) : resendEnabled ? (
                        <span
                          className={`${classes.clickable} ${classes.underLinedText}`}
                          onClick={handleResendOtp}
                        >
                          Resend code
                        </span>
                      ) : (
                        <span style={{ opacity: 0.5 }}>
                          Resend code ({formatResendTimer(resendTimer)})
                        </span>
                      )}
                    </p>
                  </>
                )}

                <p className={classes.error}>
                  {formErrors.requestError && formErrors.requestErrorText}
                </p>
                {showSignInLink && (
                  <p
                    className={classes.switchLabel}
                    style={{ textAlign: 'center', marginTop: 4 }}
                  >
                    <span
                      className={`${classes.clickable} ${classes.underLinedText}`}
                      onClick={handleSignInLinkClick}
                    >
                      Already have an account? Sign in
                    </span>
                  </p>
                )}
                {signupStep === 'form' ? (
                  <CHRButton
                    onClick={handleSignUp}
                    label="Continue"
                    icon={emailIcon}
                    isSubmitting={isSubmitting}
                    disabled={isSubmitting}
                    customStyle={classes.buttonStyles}
                  />
                ) : (
                  <CHRButton
                    onClick={handleCreateAccount}
                    label="Verify & Create Account"
                    icon={emailIcon}
                    isSubmitting={isSubmitting}
                    disabled={isSubmitting || otpValue.length !== 6}
                    customStyle={classes.buttonStyles}
                  />
                )}
                {signupStep === 'form' && (
                  <>
                    <CHRText size="small">or</CHRText>
                    <CHRButton
                      onClick={() =>
                        Auth.federatedSignIn({
                          provider: CognitoHostedUIIdentityProvider.Google,
                        })
                      }
                      label={t('join.joinWithGoogle')}
                      icon={googleIcon}
                      isSubmitting={isSubmitting}
                      disabled={isSubmitting}
                      customStyle={classes.buttonStyles}
                    />
                    <CHRButton
                      onClick={() =>
                        Auth.federatedSignIn({
                          provider: CognitoHostedUIIdentityProvider.Apple,
                        })
                      }
                      label={t('join.joinWithApple')}
                      icon={appleIcon}
                      isSubmitting={isSubmitting}
                      disabled={isSubmitting}
                      customStyle={classes.buttonStyles}
                    />
                    <div className={classes.switches}>
                      <p className={classes.error}>
                        {!isTermsChecked && t('join.termsAndConditions')}
                      </p>
                      <div className={classes.termsWrapper}>
                        <IOSSwitch
                          checked={isTermsChecked}
                          onChange={handleTermsSwitch}
                          name="terms"
                        />
                        <p className={classes.switchLabel}>
                          {t('join.accept')}{' '}
                          <span className={classes.bold}>
                            <a
                              href={ROUTES.terms}
                              target="_blank"
                              rel="noreferrer"
                              style={{ color: '#000', textDecoration: 'none' }}
                            >
                              {t('join.termsAndPrivacy')}
                            </a>
                          </span>
                        </p>
                      </div>
                      <div className={classes.termsWrapper}>
                        <IOSSwitch
                          checked={isNewsletterChecked}
                          onChange={handleNewslettersSwitch}
                          name="newsletters"
                        />
                        <p className={classes.switchLabel}>
                          {t('join.subscribeToNewsletter')}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </form>
            )}
          </ContentContainer>
          <div>
            {/*---------------------- why join - title ----------------------*/}
            <CHRText
              size={TYPOGRAPHY_SIZES.big}
              align={TYPOGRAPHY_ALIGNMENT.left}
              style={{
                alignSelf: 'center',
                width: '90%',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <span className={classes.desktop}>{t('join.whyJoin')}</span>
              <span
                className={[
                  classes.mobile,
                  classes.whyJoinMobileContainer,
                ].join(' ')}
              >
                {t('join.whyJoin')}
              </span>
            </CHRText>
            {/*---------------------- section 1 - shop millions of products ----------------------*/}
            <section className={classes.shopProductsContainer}>
              <CHRFloatImageLeft
                rightChildren={
                  <div>
                    <Typography
                      variant="h2"
                      className={[
                        classes.customWidth1,
                        classes.customWidth5,
                      ].join(' ')}
                    >
                      {t('whyJoin.shopMillionsOfProductsAndEarn')}
                    </Typography>
                    <div>
                      <Typography
                        variant="subtitle1"
                        component="p"
                        className={classes.customWidth1}
                      >
                        {t('whyJoin.shopMillionsOfProductsIn')}{' '}
                        <Link
                          to="/category/beauty"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.beauty')}
                        </Link>
                        ,{' '}
                        <Link
                          to="/category/fashion"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.fashion')}
                        </Link>
                        ,{' '}
                        <Link
                          to="/category/home"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.home')}
                        </Link>{' '}
                        {t('shared.and')}{' '}
                        <Link
                          to="/category/lifestyle"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.lifestyle')}
                        </Link>{' '}
                        {t('shared.from')}{' '}
                        <Link
                          to="/brands"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.topBrands')}
                        </Link>
                        . {t('whyJoin.allCuratedBy')}{' '}
                        <a
                          href="#"
                          className={`${classes.underLinedText} ${classes.clickable}`}
                        >
                          {t('shared.chirpyestStyleFinders')}
                        </a>
                        .
                      </Typography>
                    </div>
                    <Typography
                      variant="subtitle1"
                      component="p"
                      className={classes.customWidth1}
                    >
                      {t('whyJoin.asChirpyestMember')}
                    </Typography>
                    {isInvite && <JoinArrowButton isFloatRight />}
                  </div>
                }
                isGatsbyImg={true}
                image={data.allImageSharp.edges[4].node.fluid}
                withoutButton
              />
            </section>
            {/*---------------------- section 2 - share and earn more cash back! ----------------------*/}
            <CHRSectionContainer>
              <section>
                <CHRFloatImageRight
                  leftChildren={
                    <div>
                      <Typography
                        variant="h2"
                        className={[
                          classes.customWidth2,
                          classes.customWidth6,
                        ].join(' ')}
                      >
                        {t('whyJoin.shareAndEarn')}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        component="p"
                        className={classes.customWidth3}
                      >
                        {t('whyJoin.okayHereIsTheBigTwist')}
                      </Typography>
                      {isInvite && <JoinArrowButton isFloatRight={false} />}
                    </div>
                  }
                  isGatsbyImg={true}
                  image={data.allImageSharp.edges[2].node.fluid}
                  withoutButton
                />
              </section>
            </CHRSectionContainer>
            {/*---------------------- section 3 - earn cash back from your shopping board ----------------------*/}
            <CHRSectionContainer>
              <section>
                <CHRFloatImageLeft
                  rightChildren={
                    <div className={classes.customWidth3}>
                      <Typography variant="h2">
                        {t('whyJoin.earnCashBack')}
                      </Typography>
                      <Typography variant="subtitle1" component="p">
                        {t('whyJoin.saveItems')}
                      </Typography>
                      {isInvite && <JoinArrowButton isFloatRight />}
                    </div>
                  }
                  isGatsbyImg={true}
                  image={data.allImageSharp.edges[5].node.fluid}
                  withoutButton
                />
              </section>
            </CHRSectionContainer>
            {/*---------------------- section 4 - shop the chirpyest’s curated style finds ----------------------*/}
            <CHRSectionContainer>
              <section>
                <CHRFloatImageRight
                  leftChildren={
                    <div>
                      <Typography
                        variant="h2"
                        className={[
                          classes.customWidth4,
                          classes.customWidth5,
                        ].join(' ')}
                      >
                        {t('whyJoin.shopChirpyestCurated')}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        component="p"
                        className={[
                          classes.customWidth4,
                          classes.customWidth5,
                        ].join(' ')}
                      >
                        {t('whyJoin.followChirpyestMembers')}
                      </Typography>
                      {isInvite && <JoinArrowButton isFloatRight={false} />}
                    </div>
                  }
                  isGatsbyImg={true}
                  image={data.allImageSharp.edges[0].node.fluid}
                  withoutButton
                />
              </section>
            </CHRSectionContainer>
            {/*---------------------- section 5 - get inspiration on our blog and to your inbox! ----------------------*/}
            <CHRSectionContainer>
              <section>
                <CHRFloatImageLeft
                  rightChildren={
                    <div>
                      <Typography
                        variant="h2"
                        className={[
                          classes.customWidth4,
                          classes.customWidth5,
                        ].join(' ')}
                      >
                        {t('whyJoin.getInspiration')}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        component="p"
                        className={classes.customWidth4}
                      >
                        {t('whyJoin.exploreOurFeaturedFeeds')}
                      </Typography>
                      {isInvite && <JoinArrowButton isFloatRight />}
                    </div>
                  }
                  isGatsbyImg={true}
                  image={data.allImageSharp.edges[3].node.fluid}
                  withoutButton
                />
              </section>
            </CHRSectionContainer>
            {/*---------------------- section 6 - chirpyest works on mobile too ----------------------*/}
            <CHRSectionContainer>
              <section>
                <CHRFloatImageRight
                  leftChildren={
                    <div>
                      <Typography
                        variant="h2"
                        className={[
                          classes.customWidth2,
                          classes.customWidth5,
                        ].join(' ')}
                      >
                        {t('whyJoin.chirpyestWorksOnMobile')}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        component="p"
                        className={classes.customWidth3}
                      >
                        {t('whyJoin.browseProduct')}
                      </Typography>
                      {isInvite && <JoinArrowButton isFloatRight={false} />}
                    </div>
                  }
                  isGatsbyImg={true}
                  image={data.allImageSharp.edges[1].node.fluid}
                  withoutButton
                />
              </section>
            </CHRSectionContainer>
            {/*---------------------- what are you waiting for - go to top ----------------------*/}
            <CHRSectionContainer>
              <ContentContainer>
                <section className={classes.centered}>
                  <Typography variant="h1" component="h2">
                    {t('home.whatAreYouWaiting')}
                  </Typography>
                  <CHROutlinedButton
                    label={t('shared.backToTop')}
                    font={FONTS.Graphik.GraphikMedium}
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        behavior: 'smooth',
                      })
                    }}
                  />
                </section>
              </ContentContainer>
            </CHRSectionContainer>
          </div>
          <PinExtensionReminderPopOut
            open={isModalOpen}
            handleClose={handleClose}
          />
          <SignInModal
            handleClose={closeSignInModal}
            openStatus={isOpenSignInModal}
            setIsLoggedIn={setIsLoggedIn}
          />
        </Layout>
      )}
    </>
  )
}

export default withTranslation()(Join)

export const query = graphql`
  query {
    allImageSharp(
      filter: {
        fluid: {
          originalName: {
            in: [
              "shop-millions-of-products.png"
              "create-share-link.png"
              "your-shopping-board.png"
              "chirpyest-curated-style-finds.png"
              "inspiration-on-our-blog.png"
              "chirpyest-works-on-mobile.png"
            ]
          }
        }
      }
      sort: { order: ASC, fields: fluid___originalName }
    ) {
      edges {
        node {
          id
          fluid(maxHeight: 1024, quality: 100) {
            src
            srcSet
            base64
            aspectRatio
            originalImg
            originalName
            sizes
          }
        }
      }
    }
  }
`
